import { ref, object, number, collection, boolean } from '@gogame/schemas';

import { IS_TIME_LIMITED } from 'scenes/PromoCodes/constants';

import { compensationsValidationSchema } from '../Rewards/Compensations/schema';

const rewardSchema = object({
  id: number().required('Required'),
  value: number()
    .max(ref('maxValue'), ({ max }) => `${max} maximum`)
    .min(ref('minValue'), ({ min }) => `${min} minimum`)
    .required('Required'),
  compensations: collection(compensationsValidationSchema),
});

const timerSchema = object({
  isTimeLimited: boolean(),
  timer: number()
    .nullable(true)
    .when([IS_TIME_LIMITED], (isTimeLimited, schema) => {
      if (isTimeLimited) {
        return schema
          .min(1, 'Timer must be greater than or equal to 1')
          .required('Custom completion time is required');
      }
      return schema;
    }),
});

export const conditionRewardValidationSchema = object({
  value: number()
    .max(ref('maxValue'), ({ max }) => `${max} maximum`)
    .min(ref('minValue'), ({ min }) => `${min} minimum`)
    .required('Value is required'),

  customTimer: timerSchema,
  rewards: collection(rewardSchema).required('Rewards are required'),
});
